import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Label, Button } from 'reactstrap'
import ProjectsDashWorkFlowsMainPage, { ProactiveWorkflowsDropDownOption } from './SidebarComponents/ProjectsDashWorkFlowsMainPage'
import ProjectsDashAssetsMainPage from './SidebarComponents/ProjectsDashAssetsMainPage'
import ProjectsDashBrandsMainFile from './SidebarComponents/ProjectsDashBrandsMainFile'
import ProjectsDashProductsMainPage from './SidebarComponents/ProjectsDashProductsMainPage'

import WorkflowIcon from '../../../../../designUtils/ProjectDashboard/WorkflowIcon.svg'
import BrandsIcon from '../../../../../designUtils/ProjectDashboard/BrandsIcon.svg'
import ProductsIcon from '../../../../../designUtils/ProjectDashboard/ProductsIcon.svg'
import ProjectAssetsIcon from '../../../../../designUtils/ProjectDashboard/ProjectAssetsIcon.svg'
import BackButton from "../../../../../designUtils/Logo/BackButton.svg"
import StoreOverviewService from '../../../../../Service/DashboardServices/AccountOverviewServices/StoreServices/StoreOverviewService'
import { connect } from "react-redux";
import CustomModal from '../../../../Components/Modals/CustomModal'
import ViewProjectAsinList from '../Components/ViewProjectAsinList'

import MyTasksNew from '../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksNew.svg';
import MyTasksCompleted from '../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksCompleted.svg';
// import MyTasksInProgress from ''../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksInProgress.svg';
import MyTasksInProgress from '../../../../../../src/designUtils/OpsDashboard/MyTasks/MyTasksInProgress.svg';



function ProjectDashSideBarMainFile(props) {
    const [pageRedirect, setPageRedirect] = useState('Project Assets')
    const [allAsinList, setAllAsinList] = useState([]);
    const [showAsin, setShowAsin] = useState(false);
    const [isPreviewModeOn, setIsPreviewModeOn] = useState(false)
    const [isChecked, setIsChecked] = useState(false);
    const [selectedWorkflowId, setSelectedWorkflowId] = useState(null)


    const handlePageRedirection = (page) => {
      
        setPageRedirect(page)
    }
    const handleWorkflowChange = (workflow) => {
        setSelectedWorkflowId(workflow.id)
        setPageRedirect('Workflow')
      }
    const toggleViewAsinPopup = () => setShowAsin(prev => !prev);

    useEffect(()=>{
        console.log(props.selectedProjectData);
        props.dispatch(
            StoreOverviewService(
                props.token,
                props.selectedProjectData.integerId,
                props.selectedProjectData.storeStringId,
            )
          )
          let data = {
            integerId:props.selectedProjectData.integerId
        }
         
   
    },[])
    useEffect(() => {
        // Handle notification redirects to specific tabs
        if (props.notificationsDetails && props.notificationsDetails.action) {
          if (props.notificationsDetails.tabs === 2) {
            setPageRedirect('Project Assets');
          } else if (props.notificationsDetails.tabs === 1) {
            setPageRedirect('Workflow');
          }
        }
      }, [props.notificationsDetails]);
   
    const showAsinList = (asinlist,projectData) => {
        const asinArray = asinlist.split(',').map(asin => asin.trim());
        setAllAsinList(asinArray)
        props.setProjectDetailsForEdit(projectData);
        setShowAsin(true)
      }
    return (
        <Row className='mt-5' style={{ width: '100%',marginLeft:'-6px'}}>
          
            <Col md={2} className='mt-3' style={{ maxWidth: '25%' }}>
                <Card className='projectDash-details-sidebar mt-3'>
                { props.projectPermissions && props.projectPermissions.ProjectDashboard_ProjectDetailsProjectAssetsMenu ?
                    <h5
                        onClick={() => handlePageRedirection('Project Assets')}
                        className={`mb-1 cursor-pointer project-dashboard-sidebar ${pageRedirect === 'Project Assets' ? 'active' : ''}`}
                    >
                        <img src={ProjectAssetsIcon} alt="Project Assets" className="mt-2 project-dashboard-sidebar-icon" />
                        Project Assets
                    </h5>:''}
                    <div className="sidebar-divider"></div>
                { props.projectPermissions && props.projectPermissions.ProjectDashboard_ProjectDetailsWorkflowsMenu ?
                    // <h5
                    //     onClick={() => handlePageRedirection('Workflow')}
                    //     className={`mb-2 cursor-pointer project-dashboard-sidebar ${pageRedirect === 'Workflow' ? 'active' : ''}`}
                    // >
                    //     <img src={WorkflowIcon} alt="Workflow" className="mt-2 project-dashboard-sidebar-icon" />
                    //     Workflow
                    // </h5>
                    <div className="mb-1 workflow-project-dashboard-sidebar">
                         <ProactiveWorkflowsDropDownOption
                    buttons={props.selectedProjectData && props.selectedProjectData.workflowsList || []}
                    handleWorkflowChange={handleWorkflowChange}
                    pageRedirect={pageRedirect}
                  />

                    </div>
                   :''}
                { props.projectPermissions && props.projectPermissions.ProjectDashboard_ProjectDetailsBrandsMenu ?

                    <h5
                        onClick={() => handlePageRedirection('Brands')}
                        className={`mb-1 cursor-pointer project-dashboard-sidebar ${pageRedirect === 'Brands' ? 'active' : ''}`}
                    >
                        <img src={BrandsIcon} alt="Brands" className="mt-2 project-dashboard-sidebar-icon" />
                        Brands
                    </h5>:''}
                { props.projectPermissions && props.projectPermissions.ProjectDashboard_ProjectDetailsProductsMenu ?
                    <h5
                        onClick={() => handlePageRedirection('Products')}
                        className={`mb-1 cursor-pointer project-dashboard-sidebar ${pageRedirect === 'Products' ? 'active' : ''}`}
                    >
                        <img src={ProductsIcon} alt="Products" className="mt-2 project-dashboard-sidebar-icon" />
                        Products
                    </h5>:''}
                </Card>
            </Col>
            <Col md={10} className='mt-3'  >
            {/* redirected notification details note */}
            {props.isMyworksScreen === true && props.notificationsDetails && props.notificationsDetails.action ? (
                <Card className="notification-card p-3 mb-2 mt-2 card-of-problemarea">
                    <Row>
                    <Col md={10}>
                        <strong>{props.notificationsDetails.details}</strong>
                    </Col>
                    <Col md={2} className="text-end">
                        <Button 
                        close
                        onClick={() =>
                            props.setNotificationsDetails({
                            tabs: 1,
                            details: '',
                            action: false,
                            searchparams: ''
                            })
                        }
                        className="close-button"
                        />
                    </Col>
                    </Row>
                </Card>
                ) : null} 
                <>  <Card className="project-header-card border mb-2 mt-3 p-2 ml-3 text-center">
              <h4
                  className="project-header-title mb-0"
                  title={props.selectedProjectData.projectName}
              >
                  <b>Project : </b> {props.selectedProjectData.projectName}
              </h4>
      </Card>
      <Card className="card-of-problemarea p-2 ml-3">
      <Row className="align-items-center mr-2">
          <Col md={12} className='mb-3'>
          <Row className="align-items-center mt-2">
              <Col md={2} className="d-flex align-items-center">
              <button
                  className="back-button-header"
                  onClick={props.onBackHeader}
                  style={{ padding: 0, border: 'none', background: 'transparent' }}
              >
                  <img src={BackButton} alt="Back" />
              </button>
              <span style={{ paddingLeft: '20px' }}>
                  <b>Id : </b> {props.selectedProjectData.projectId}
              </span>
              </Col>
              <Col md={4} className='comment-paragraph'>
              <span 
              title={
                Array.isArray(props.selectedProjectData.workflow)
                  ? props.selectedProjectData.workflow.map(function (w) {
                      return (w && typeof w === 'object') ? (w.name || '') : w;
                    }).filter(Boolean).join(', ')
                  : (props.selectedProjectData.workflow || '')
              }
              >
                  <b>Workflow : </b>{' '}
                  {
                    Array.isArray(props.selectedProjectData.workflow)
                      ? props.selectedProjectData.workflow.map(function (w) {
                          return (w && typeof w === 'object') ? (w.name || '') : w;
                        }).filter(Boolean).join(', ')
                      : (props.selectedProjectData.workflow || '')
                  }
              </span>
              </Col>
              <Col md={4}>
              <span className='d-flex'>
                  <b>
                      Website : </b> 
                      <p className='m-0 comment-paragraph cursor-pointer ml-1'>
                          <a 
                          href={props.selectedProjectData.website} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{color: 'inherit', textDecoration: 'none'}}
                      >
                         {props.selectedProjectData.website}
                      </a>
                      </p>
              </span>
              </Col>
              <Col md={2}>
              <Label className="d-flex justify-content-center" style={{ paddingLeft: '50px' }}>
                  <span className="projectstatus d-flex align-items-center gap-2">
                  {props.selectedProjectData.projectStatus === "New" ? (
                      <>
                      <img src={MyTasksNew} alt="New" />
                      <b>New</b>
                      </>
                  ) : props.selectedProjectData.projectStatus === "In Progress" ? (
                      <>
                      <img src={MyTasksInProgress} alt="In Progress" />
                      <b>In Progress</b>
                      </>
                  ) : props.selectedProjectData.projectStatus === "Completed" ? (
                      <>
                      <img src={MyTasksCompleted} alt="Completed" />
                      <b>Completed</b>
                      </>
                  ) : (
                      <b>{props.selectedProjectData.projectStatus}</b>
                  )}
                  </span>
              </Label>
              </Col>
          </Row>
          <Row className="align-items-center ml-3">
              <Col md={2}>
              <span className="comment-paragraph-project-storename" title={props.selectedProjectData.accountName}>
                  <b>Account : </b> {props.selectedProjectData.accountName}
              </span>
              </Col>
              <Col md={4}>
              <span className="comment-paragraph-project-details" title={props.selectedProjectData.brand}>
                  <b>Brand : </b> {props.selectedProjectData.brand}
              </span>
              </Col>
              <Col md={4}>
              <span className="comment-paragraph-project-details" title={props.selectedProjectData.owner}>
                  <b>Owner : </b> {props.selectedProjectData.owner}
              </span>
              </Col>
              <Col md={2}>
              <span className="comment-paragraph-project-details">
                  <b>Start Date :</b> {props.selectedProjectData.startDate}
              </span>
              </Col>
          </Row>
          <Row className="align-items-center mt-2 ml-3">
              <Col md={2}>
              <span className="comment-paragraph-project-storename" title={props.selectedProjectData.storeName}>
              <b>Store : </b>
              <a href={props.selectedProjectData.store_link} target="blank" rel="noopener noreferrer">
              {props.selectedProjectData.storeName}
              </a>
              </span>
              </Col>
              <Col md={4}>
              <b>Asin List : </b>
              <span
                  className="comment-paragraph-project-details"
                  title={props.selectedProjectData.asin}
                  style={{ color: "#3D85C6", cursor: "pointer" }}
                  onClick={() => showAsinList(props.selectedProjectData.asin,props.selectedProjectData)}
              >
                  {props.selectedProjectData.asin || '-'}
              </span>
              </Col>
              <Col md={4}>
              <span className="comment-paragraph-project-details"
               title={props.selectedProjectData.graphicDesigner}>
                  <b>Graphic Designer : </b> {props.selectedProjectData.graphicDesigner}
              </span>
              </Col>
              <Col md={2}>
              <span className="comment-paragraph-project-details">
                  <b>Due Date : </b> {props.selectedProjectData.dueDate}
              </span>
              </Col>
          </Row>
          </Col>
      </Row>
      </Card></>

           
              

                {pageRedirect == 'Workflow' && <ProjectsDashWorkFlowsMainPage
            projectPermissions={props.projectPermissions}
            selectedProjectData={props.selectedProjectData}
            selectedWorkflowMasterId={selectedWorkflowId}
          />}
                {pageRedirect == 'Brands'  &&
                 <ProjectsDashBrandsMainFile
                 projectPermissions={props.projectPermissions}
                  selectedProjectData={props.selectedProjectData}
                   page={pageRedirect}
                    />}
                { pageRedirect == 'Project Assets'  &&<ProjectsDashAssetsMainPage
                projectPermissions={props.projectPermissions}
                selectedProjectData={props.selectedProjectData}
                page={pageRedirect}
                />}
                {pageRedirect == 'Products' && <ProjectsDashProductsMainPage
                projectPermissions={props.projectPermissions}
                 selectedProjectData={props.selectedProjectData} />}
                {/* {pageRedirect=='Project Assets'&&<ProjectsDashAssetsMainPage/> } */}

            </Col>
        <CustomModal
            header={
              <span>
              <b>{props.projectDetailsForEdit && props.projectDetailsForEdit.projectName } </b> : ASIN List
            </span>
            }
            isOpen={showAsin}
            toggle={toggleViewAsinPopup}
            size={"lg"}
            className='curve-popup my-task-custom-module'
          >
            <ViewProjectAsinList
              projectData={props.projectDetailsForEdit}
              asinList={allAsinList}
            />
      </CustomModal>
        </Row>

        
    )
}

const mapStateToProps = (state) => ({
    token: state.loggedUser.token,
    storeOverview: state.accountOverview.store.storeOverview,
    UserPermission: state.accountOverview.store.StoreUserPermission,
  });
  
  export default connect(mapStateToProps)(ProjectDashSideBarMainFile);
